import { render, staticRenderFns } from "./modalDesvincularAfiliado.vue?vue&type=template&id=3b5a3c1e"
import script from "./modalDesvincularAfiliado.vue?vue&type=script&lang=js"
export * from "./modalDesvincularAfiliado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports